import { signOut } from 'next-auth/react';
import posthog from 'posthog-js';

import { routes } from '../constants/routes';

export function handleSignOut() {
  const signOutRedirectUrl = routes.MAIN;
  posthog.reset();
  return signOut({
    callbackUrl: signOutRedirectUrl,
  });
}
